var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCloseSmall = function SvgCloseSmall(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c1b1f",
    d: "m9.904 11.28-2.68 2.678a.58.58 0 0 1-.434.176.6.6 0 0 1-.435-.184.6.6 0 0 1-.18-.438q0-.26.18-.44l2.671-2.67-2.679-2.66a.58.58 0 0 1-.175-.438.6.6 0 0 1 .183-.439q.18-.18.44-.18.258 0 .438.18l2.671 2.68 2.659-2.68q.18-.18.435-.18t.435.18a.6.6 0 0 1 .192.445.57.57 0 0 1-.192.433L10.76 10.4l2.68 2.68q.18.18.179.434 0 .256-.18.435a.6.6 0 0 1-.445.193.57.57 0 0 1-.432-.193z"
  })));
};
export default SvgCloseSmall;